import { watch } from 'vue'

function useBodyLockSwitcher(booleanRef) {
const scrollbarWidth = window?.innerWidth - document.body?.clientWidth
document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`)
watch(booleanRef,() => {
  if (booleanRef?.value) {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "unset";
  } else {
    document.documentElement.style.overflow = "visible";
    document.body.style.overflow = "visible";
  }
})
}

export {
  useBodyLockSwitcher
}